module.exports = __webpack_public_path__ + "229ef738461f8313e5d85593c86a7d5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2000_36_teaser_image.jpg
// module id = 548
// module chunks = 0